import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "../components/home/HeroSection";
import WhyApplumoSection from "../components/home/WhyApplumoSection";
import StatsStrip from "../components/home/StatsStrip";
import WhatWeDoSection from "../components/home/WhatWeDoSection";
import HowWeWorkSection from "../components/home/HowWeWorkSection";
import VisionMissionSection from "../components/home/VisionMissionSection";
import OurWorkSection from "../components/home/OurWorkSection";
import ChallengeCtaSection from "../components/home/ChallengeCtaSection";
import useLang from "../hooks/useLang";

// The landing page: each section is its own component in components/home/, in page order.
const Home = () => {
  const { dir } = useLang();
  const location = useLocation();

  // Arriving from the "How We Work" menu on another page scrolls to the flow.
  useEffect(() => {
    if (location.state?.scrollTo !== "how-we-work") return undefined;
    const id = setTimeout(
      () => document.getElementById("how-we-work")?.scrollIntoView({ behavior: "smooth", block: "start" }),
      450
    );
    return () => clearTimeout(id);
  }, [location.state]);

  return (
    <div dir={dir} className="font-inter">
      <HeroSection />
      <WhyApplumoSection />
      <StatsStrip />
      <WhatWeDoSection />
      <HowWeWorkSection />
      <VisionMissionSection />
      <OurWorkSection />
      <ChallengeCtaSection />
    </div>
  );
};

export default Home;
